import {computed, inject, reactive} from "vue";
import axios from 'axios'
import {useCookies} from "vue3-cookies";
import {useStore} from "vuex";
import {useRouter} from 'vue-router'

import moment from "moment";


const commonMgt = () => {

    const store = useStore();
    const { cookies } = useCookies();
    const CryptoJS = require("crypto-js");
    const emitter = inject("emitter");
    const router = useRouter();

    let commonState = reactive({
        debug: true,  /* 상용 적용시 false */
        errorCode: {
            'OK': 'SUCCESS',
            'PA02': '유효한 설정값를 입력해 주세요.',
            'FAIL': '예기치 못한 오류가 발생하였습니다. 재 시도 해 주시기 바랍니다.',
            'LOGINFAIL': '아이디 또는 비밀번호를 잘못 입력하셨습니다.',
            'AUTHFAIL': '인증번호가 입력되지 않았거나 잘못 입력하셨습니다',
            'BO0006': '비밀번호를 5회 이상 잘못 입력하여 계정이 잠금처리 되었습니다.\n 잠금 해제는 관리자에게 문의하세요',
            'OVETIME': '입력 시간이 초과되었습니다. \n 다시 인증번호 재 요청을 클릭하시기 바랍니다',
            'CONFIRMCREATE': '등록 하시겠습니까?',
            'CONFIRMRESET': '초기화 하시겠습니까?',
            'CONFIRMSAVE': '저장 하시겠습니까?',
            'CONFIRMDELETE': '삭제 하시겠습니까?',
            'COMPLETE': '완료 되었습니다.',
            'NOTDATA': '서버로 부터 Data를 전송 받지 못했습니다.(retry)',
        },

        selectBtn: {
            'alter': 'alterBtn',
            'confirm': 'confirmBtn'
        },

        userInfo: {
            managerId: "",
            managerPassword: "",
            authNo: "",
            //uuid: uuidv4(),
        },
        getPartnerAccessToken: computed(() => store.getters["staLogin/getPartnerAccessToken"]),

    });

    const common = {
        https: (str) => {

            axios.defaults.baseURL = process.env.VUE_APP_POTAL_MARKET_API_URL;
            axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
            axios.defaults.headers.common['Access-Control-Allow-Credential'] = true;
            axios.defaults.withCredentials = true;
            axios.defaults.headers.common['Content-Type'] = 'application/json; charset = utf-8';
            axios.defaults.headers.common['managerId'] = store.getters["staLogin/getLoginId"];
            // delete axios.defaults.headers.common['X-Requested-With'];
            return axios

        },

        /* 10이하 숫자를 0을 붙여 2자리 숫자 만들어줌 */
        toTwoDigits: (num) => {
            let txt = ''
            if (num < 10)
                txt = '0' + num
            else txt += num
            return txt
        },
        log: (tag, msg) => {
            if (!commonState.debug) {
                return;
            }

            if (tag != undefined && msg != undefined) {
                console.log(tag, msg);
            } else {
                console.log(tag);
            }

        },
        templateDownload: (fileName, authorization, downloadName) => {
            emitter.emit("myevent", true);
            common.https()
                ({
                    method: "POST",
                    url: 'partner/common/downLoadTemplatFile',
                    responseType: "blob",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                    data: {
                        fileName: fileName
                    },
                }).then((response) => {

                    emitter.emit("myevent", false);
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    if (common.isEmpty(downloadName)) {
                        link.download = fileName;
                    } else {
                        link.download = downloadName;
                    }

                    link.click();
                    URL.revokeObjectURL(link.href);

                }).catch(function (error) {
                    emitter.emit("myevent", false);
                    common.log("", error);
                });
        },
        // 현재 일시를 전달된 Format 문자열로 반환:
        getDateTime(strFmt, passVal = 0, passMode = "days") {
            return (passVal == 0) ? moment().format(strFmt) : moment().add(passVal, passMode).format(strFmt)
        },
        isEmpty: (value) => {
            if (
                value === '' || value === null || value === undefined
                || (value !== null && typeof value === 'object' && !Object.keys(value).length)
                || (value !== null && Array.isArray(value) && !value.length)
            ) {
                return true
            } else {
                return false
            }
        },
        isEmptyAndInit: (checkVal, returnVal) => {
            if (checkVal === "" || checkVal === null || checkVal === undefined
                || (checkVal !== null && typeof checkVal === "object" && !Object.keys(checkVal).length)
                || (checkVal !== null && Array.isArray(checkVal) && !checkVal.length)
            )
                return returnVal
            else
                return checkVal
        },

        //이메일 정규식
        emailValidation: (data) => {
            var regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
            if (regExp.test(data)) {
                //통과
                return true;
            } else {
                //올바르지 않음
                return false;
            }
        },

        makeComma: (val) => {
            var firstStr = "";
            var returnVal = val;
            if (val != "" && val != undefined) {
                firstStr = String(val).substring(0, 1)
                val = String(val).replace(/[^0-9]/g, '')
                returnVal = (firstStr == '-' ? '-' : "") + String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }

            return returnVal;
        },

        replace: (val, before, after) => {
            var returnVal = val;
            if (val != "" && val != undefined) {
                returnVal = val.replaceAll(before, after)
            }

            return returnVal;
        },
        encryptRsa: (cipherText) => {
            try {
                if (cipherText == null || cipherText == '') { return cipherText; }
                var rsa = new RSAKey();
                var pkm = process.env.VUE_APP_PUB_KEY_MOD;
                var pke = process.env.VUE_APP_PUB_KEY_EXP;
                rsa.setPublic(pkm, pke);
                return rsa.encrypt(cipherText);
            } catch (err) {
                common.log("real data api errorcheck : ==>", err);
            }
        },
        decryptAyncCookies: async (showLoginId) => {
            var cipherText = showLoginId;
            if (cipherText == null || cipherText == '') { return cipherText; }
            const pheaders = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: store.getters["staLogin/getPartnerAccessToken"]
                }
            };

            const reqBody = {
                showLoginId: showLoginId
            };
            //로그인시 서버 복호화 호출
            const res = await common.https(true).post("partner/user/getCookieDecrypt", reqBody, pheaders);
            const data = await res.data.data;
            return data;
        },

        checkResult: (res) => {

            if (res.status != 200) {
                return 0
            }
            if (typeof res.data == "undefined" || res.data == null) {
                return 0
            }
            if (res.data.retCode == "CM0000") {
                return 1
            }

            if (!common.isEmpty(res.data.retCode)) {
                return 0;
            }
            if (commonState.debug) {
                common.log("checkResult", res);
            }

            return 0
        },



        link: path => {
            window.location.href = path;
        },
        getCode: async (codeId) => {

            const res = await common.https().post("partner/common/getCodeList", { 'codeId': codeId });
            const data = await res.data.data;
            return data;
        },
        getCodeNoStatus: async (codeId) => {

            const res = await common.https().post("partner/common/getCodeListNoStatus", { 'codeId': codeId });
            const data = await res.data.data;
            return data;
        },
        loginCheck: (str) => {
            if (str == undefined && !str) {
                var authorization = store.getters["staLogin/getPartnerAccessToken"];
                if (!common.isEmpty(authorization)) {
                    emitter.emit("myLogin", true);
                    return 1;
                } else {
                    return 0;
                }
            }
            return 1;
        },
        getMember: async (redirect) => {
            var authorization = store.getters["staLogin/getPartnerAccessToken"];
            var logoutTime = store.getters["staLogin/getLoginChekcTime"];
            var result = true;
            if (common.isEmpty(authorization) || common.isEmpty(logoutTime)) {
                store.commit("staLogin/setLoginPopup", true);
                if (redirect != null) {
                    store.commit("staLogin/setRedirect", redirect);
                }
                router.push({ name: 'Login' });
                return false;
            }
            const today = moment()
            const time = moment(logoutTime, 'YYYYMMDDHHmmss')

            var count = moment.duration(time.diff(today)).minutes()
            if (count < 5) {
                var response = await common.https().post('partner/user/loginCheck', { 'accessToken': authorization })
                if (response.data.data != '200') {
                    store.commit("staLogin/setLoginPopup", true);
                    router.push({ name: 'Login' });
                    return false;
                } else {
                    emitter.emit("myLogin", true);
                }
            } else {
                emitter.emit("myLogin", true);
            }
        },
        productPossession: async (memSq) => {
            var response = await common.https().post('partner/product/productPossession', { 'memSq': memSq })
            const result = await response.data.data.count > 0 ? true : false;
            return result;
        },
        tokenRefresh: async () => {
            var accessToken = store.getters["staLogin/getPartnerAccessToken"];
            var response = await common.https().post('partner/user/tokenRefresh', { 'accessToken': accessToken })
            if (response.data.data.code != '200') {
                router.push({ name: 'Login' });
                return false;
            } else {
                if (response.data.data.timeout != undefined && response.data.data.timeout != 'null') {
                    var timeout = response.data.data.timeout.replace("timeout=", "")
                    store.commit("staLogin/setLoginChekcTime", moment().add(Number(timeout), 'minutes').format('YYYYMMDDHHmmss'))
                } else {
                    store.commit("staLogin/setLoginChekcTime", moment().add(60, 'minutes').format('YYYYMMDDHHmmss'))
                }
                //토큰
                if (response.data.data.token != undefined && response.data.data.token != 'null') {
                    store.commit("staLogin/setPartnerAccessToken", response.data.data.token);
                    //JWT 토큰
                    cookies.set("jwtToken", response.data.data.jwtToken);
                    emitter.emit("myLogin", true);
                    emitter.emit("isLogin", true);
                } else {
                    router.push({ name: 'Login' });
                    return false;
                }

            }

        },
        /**
         * 파일명에서 확장자명 추출
         * @param filename   파일명
         * @returns _fileExt 확장자명
         */
        getExtensionOfFilename: (filename) => {
            var _fileLen = filename.length;

            /** 
             * lastIndexOf('.') 
             * 뒤에서부터 '.'의 위치를 찾기위한 함수
             * 검색 문자의 위치를 반환한다.
             * 파일 이름에 '.'이 포함되는 경우가 있기 때문에 lastIndexOf() 사용
             */
            var _lastDot = filename.lastIndexOf('.');

            // 확장자 명만 추출한 후 소문자로 변경
            var _fileExt = filename.substring(_lastDot + 1, _fileLen).toLowerCase();

            return _fileExt;
        },
        // Excel 다운로드 전용: header.headers, 크롬/파이어폭스/사파리 공용 Ext
        postExcelDownloadFile(url, filename, header, body, func) {
            return this.postSaveFile(url, filename, header.headers, body, func,
                "application/vnd.ms-excel");
        },
        postSaveFile(url, saveName, header, body, func, ext) {
            this.https()
                ({
                    method: "POST",
                    url: url,
                    responseType: "blob",
                    headers: header,
                    data: body,
                })
                .then((response) => {
                    const blob = new Blob([response.data], { type: "application/" + ext });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = saveName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                    func()  // emitter.emit("myevent", false); 는 호출한 곳에서!!!
                })
                .catch(function (error) {
                    func()
                    this.log("postSaveFile err::", error);
                });
        },
        getDateTimeStr(modeStr) {
            var s = ""
            var fmt = ""

            switch (modeStr) {
                case "D": fmt = "YYYYMMDD"; break;
                case "d": fmt = "YYMMDD"; break;
                case "T": fmt = "HHmmss"; break;
                case "t": fmt = "HHmm"; break;
                case "DT": fmt = "YYYYMMDD_HHmmss"; break;
                default: fmt = "YYYYMMDD"; break;
            }

            s = this.getDateTime(fmt)
            return s
        },
        EditorStringToReplace(content) {
            // 정규 표현식 패턴
            let pattern = /<iframe.*?<\/iframe>/g;
            if (content && content.trim() !== "") {
                content = content.replace(pattern, "");
            }
            return content;
        },
        // 이미지 상태 체크
        getImageStatus: async (productEntrySeq) => {
            const response = await common.https().post("partner/productImage/getImageStatus", {'productEntrySeq': productEntrySeq});
            console.log(response)
            if(response.data != null){
                return response.data
            }else{
                return null;
            }

        },
    }

    return { common }
}

export default commonMgt;